import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKCARTLOYALTYBLOCK_LEGACY_FIELD_ORDER = [
  "heading",
  "subheading",
  { type: 'separator' },
  "background_color",
  "text_color",
  { type: 'separator' },
  "secondary_button_background_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskCartLoyaltyBlockDescriptor: _generatedKioskCartLoyaltyBlockDescriptor,
  kioskCartLoyaltyBlockBlocDefinition,
  kioskCartLoyaltyBlockDashboardLayout,
  kioskCartLoyaltyBlockConfig,
  kioskCartLoyaltyBlockResolveConfig,
  kioskCartLoyaltyBlockProperties,
} = doodBlockConfig(
  {
    name: "Kiosk Cart - Loyalty",
    componentType: 'KioskCartLoyaltyBlockComponent',
    category: 'kiosk',
    description: "Kiosk Cart - Loyalty.",
    keywords: [],
    allowedIn: [
      { bloc: 'KioskCartPageComponent', slot: 'body' },
    ],


    sharedFields: {}
  },

  () => ({
    heading: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-loyalty.heading.label",
      }
    }),
    subheading: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-loyalty.subheading.label",
      }
    }),
    primary_button_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-cart-loyalty.primary-button-background-color.label",
      }
    }),
    primary_button_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-50"},
      options: {
        label: "pages.blocks.kiosk-cart-loyalty.primary-button-text-color.label",
      }
    }),
    secondary_button_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-50"},
      options: {
        label: "pages.blocks.kiosk-cart-loyalty.secondary-button-background-color.label",
      }
    }),
    secondary_button_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-cart-loyalty.secondary-button-text-color.label",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.kiosk-cart-loyalty.background-color.label",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#000"},
      options: {
        label: "pages.blocks.kiosk-cart-loyalty.text-color.label",
      }
    }),
    connexion_heading: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-loyalty.connexion-heading.label",
      }
    }),
    connexion_card_label: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-loyalty.connexion-card-label.label",
      }
    }),
    link_connexion: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-cart-loyalty.link-connexion.label",
      }
    })
  }),

  () => ({
    omitFields: [
      "primary_button_background_color",
      "primary_button_text_color",
      "secondary_button_text_color",
      "connexion_heading",
      "connexion_card_label",
      "link_connexion",
    ] as const,
    tabs: [
      {
        label: "pages.blocks.kiosk-cart-loyalty.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-cart-loyalty.fieldset.texts.label",
            fields: ["heading", "subheading", "text_color"],
          },
          {
            legend: "pages.blocks.kiosk-cart-loyalty.fieldset.card.label",
            fields: ["background_color", "secondary_button_background_color"],
          },
        ],
      },
    ],
  })
);

export function kioskCartLoyaltyBlockDescriptor(): IBlockDescriptor;
export function kioskCartLoyaltyBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskCartLoyaltyBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskCartLoyaltyBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskCartLoyaltyBlockDescriptor, kioskCartLoyaltyBlockProperties, fieldOrder);
}

export {
  kioskCartLoyaltyBlockBlocDefinition,
  kioskCartLoyaltyBlockDashboardLayout,
  kioskCartLoyaltyBlockProperties,
  kioskCartLoyaltyBlockConfig,
  kioskCartLoyaltyBlockResolveConfig,
};

export type KioskCartLoyaltyBlockConfig = typeof kioskCartLoyaltyBlockConfig;
